import smartlookClient from 'smartlook-client'
import environment from '@/environment'

let isInitialized = false

export interface UserProfile {
    id: number | string;
    fullName: string;
}

export function bootstrapSmartlook() {
    if (isInitialized || environment.smartlookProjectId === undefined) {
        return
    }

    smartlookClient.init(environment.smartlookProjectId)
    isInitialized = true
}

export function smartlookIdentify(userProfile: UserProfile) {
    if (userProfile.id == null) {
        return
    }

    if (!isInitialized) {
        bootstrapSmartlook()
    }

    smartlookClient.identify(userProfile.id, {
        displayName: userProfile.fullName,
        environment: environment.type,
        platform: window.location.hostname,
    })
}
